import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { UserSetting } from '@/models/UserSetting';
import { CookieStorageService } from '@questelservices/common';
import { CookieKeysEnum } from '@questelservices/common';


@Module({ name: 'user-settings' })
export default class UserSettingsModule extends VuexModule {
    private cookieService: CookieStorageService = new CookieStorageService();
    private userSetting: string = "";

    @Mutation
    protected SET_USER_SETTINGS(settings: UserSetting[]): void {
      this.userSetting = JSON.stringify(settings);

      if (settings) {
        this.cookieService.setItem(CookieKeysEnum.UserSettings, this.userSetting);
      } else {
        this.cookieService.removeItem(CookieKeysEnum.UserSettings);
      }
    }

    public get userSettings(): string {
        return this.userSetting;
    }

    @Action({ commit: 'SET_USER_SETTINGS' })
    public async setUserSettings(settings: UserSetting[]): Promise<UserSetting[]> {
        return settings;
    }
}
